import React, { useRef, useEffect, useState, useContext } from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { Button } from 'react-bootstrap';
import { BsLink45Deg, BsExclamationSquare, BsExclamationCircle, BsPinMap, BsChevronDown, BsChevronRight} from 'react-icons/bs';
import { RxCounterClockwiseClock  } from "react-icons/rx";
import {strArraySortAsc, createNewTab, parse_metrics_body, useInterval, saveIfChange,
        getSession_Json, updateSession} from '../../common/app_common';
import {CheckEdgeMetric} from '../../common/component_common';
import {getApiSitesSite} from '../../common/fetch_api/site';
import {getApiEdgeId, getApiEdgeIdMetrics} from '../../common/fetch_api/edge';
import {EdgeInfoModal} from '../control_site_manager/modals';
import {HistoryModal, AlertModal, EdgeWidgetConfigModal} from './modals';
import * as Media from '../sites_list/media';
import * as Scheduler from '../sites_list/scheduler';
import * as Redundant from '../sites_list/redundant';
import * as Transmitter from '../sites_list/transmitter';
import {TermRefreshContext} from '../../pages/sites_list';
import '../../common/css/markdown.css';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkToc from 'remark-toc';
import rehypeRaw from 'rehype-raw';
import rehypeHighlight from 'rehype-highlight';
import rehypeSanitize from 'rehype-sanitize';
import Collapse from 'react-bootstrap/Collapse';

export const SiteOffCanvas = ({siteUpdate, siteName, result, moveLocation, show, handleClose}) => {
    
    const [memoHeight, setMemoHeight] = useState(400);
    const [memoColl, setMemoColl] = useState(true);
    const toggleMemoColl = () => {
        updateSession('siteWidgetInfo', 'collapse', !memoColl);
        setMemoColl(!memoColl);
    }

    const [siteInfo, setSiteInfo] = useState(
        {
            "name": "",
            "market": "",
            "longitude": 0,
            "latitude": 0,
            "memo": "",
            "date": "",
            "frequency": 0,
            "exciterLatitude": 0,
            "exciterLongitude": 0,
            "transmissionStationList": [],
            "changeCount": 0,
            "severity": "warning",
            "edgeList": []
        }
    );
    const [edgeList, setEdgeList] = useState(null);
    
    const [modalEdgeAlert, setModalEdgeAlert] = useState(false);
    const closeModalEdgeAlert = () => setModalEdgeAlert(false);
    const showModalEdgeAlert = () => setModalEdgeAlert(true);
    
    const [modalEdgeHistory, setModalEdgeHistory] = useState(false);
    const closeModalEdgeHistory = () => setModalEdgeHistory(false);
    const showModalEdgeHistory = () => setModalEdgeHistory(true);

    const [edgeInfoId, setEdgeInfoId] = useState(null);
    const [modalEdgeInfo, setModalEdgeInfo] = useState(false);
    const closeModalEdgeInfo = () => setModalEdgeInfo(false);
    const showModalEdgeInfo = (edgeId) => {
        setEdgeInfoId(edgeId);
        setModalEdgeInfo(true);
    }

    function goToEdgeCanvas(edgeId)
    {
        Promise.resolve( getApiEdgeId(edgeId) )
        .then( edgeData => {
            closeOffcanvas();
            result(edgeData);
        });
    }

    function getSiteInfo()
    {
        Promise.resolve( getApiSitesSite(siteName) )
        .then( data => {
            setSiteInfo(data);
        });
    }

    function createEdgeList()
    {
        const mAgentArr = siteInfo.edgeList.filter((x) => {return x.type === 'm-agent'});
        const sAgentArr = siteInfo.edgeList.filter((x) => {return x.type === 's-agent'});
        const rAgentArr = siteInfo.edgeList.filter((x) => {return x.type === 'r-agent'});
        const rmArr = siteInfo.edgeList.filter((x) => {return x.type === 'rm'});

        mAgentArr.sort((a, b) => strArraySortAsc(a.tag.toLowerCase(), b.tag.toLowerCase()));
        sAgentArr.sort((a, b) => strArraySortAsc(a.tag.toLowerCase(), b.tag.toLowerCase()));
        rAgentArr.sort((a, b) => strArraySortAsc(a.tag.toLowerCase(), b.tag.toLowerCase()));
        rmArr.sort((a, b) => strArraySortAsc(a.tag.toLowerCase(), b.tag.toLowerCase()));

        let edgeArr = [...mAgentArr, ...sAgentArr, ...rAgentArr, ...rmArr];
        const edgeTypeToLetter = (type) => type === 'm-agent' ? 'M' : type === 's-agent' ? 'S' : type === 'r-agent' ? 'R' : 'T';
        setEdgeList( Object.keys(edgeArr).map((key) =>
            <tr key={edgeArr[key].id} >
                <td>
                    <div className={`pointer edge-box bg-${edgeArr[key].severity}`} onClick={()=>{goToEdgeCanvas(edgeArr[key].id)}}>{edgeTypeToLetter(edgeArr[key].type)}</div>
                </td>
                <td>
                    <div className="pointer label-edge" onClick={()=>{goToEdgeCanvas(edgeArr[key].id)}}>{`${edgeArr[key].tag.length > 0?edgeArr[key].tag:'-'}`}</div>
                </td>
                <td>
                    <div className="pointer label-edge" onClick={()=>{goToEdgeCanvas(edgeArr[key].id)}}>{edgeArr[key].name}</div>
                </td>
                <td>
                    <Button vatiant='primary' className="btn btn-icon" data-bs-toggle="tooltip" title="Details" onClick={()=>{showModalEdgeInfo(edgeArr[key].id)}}><BsExclamationCircle></BsExclamationCircle></Button>
                </td>
                <td>
                    <Button vatiant='primary' className="btn btn-icon" data-bs-toggle="tooltip" title="Link to Device" onClick={()=>{
                        Promise.resolve( getApiEdgeId(edgeArr[key].id) )
                        .then( edgeData => {
                            createNewTab(edgeData.link)
                        });
                    }}><BsLink45Deg></BsLink45Deg></Button>
                </td>
                <td>
                    <Button vatiant='primary' className="btn btn-icon" data-bs-toggle="tooltip" title="Location" onClick={()=>{moveLocation([edgeArr[key].longitude, edgeArr[key].latitude])}}><BsPinMap></BsPinMap></Button>
                </td>
            </tr>
        ));
    }

    const closeOffcanvas = () => {
        handleClose();
        show = false;
    }

    useEffect( () => {
        getSiteInfo();
        
        const get = getSession_Json('siteWidgetInfo');
        if( get !== null )
        {
            saveIfChange(setMemoColl, get.collapse);
            saveIfChange(setMemoHeight, get.height);
        }
    }, [show, siteUpdate]);

    useEffect( () => {
        createEdgeList();
    }, [JSON.stringify(siteInfo)]);

    return (
        <>
            <Offcanvas show={show} onHide={closeOffcanvas} placement="end">
                <Offcanvas.Header>
                    <Offcanvas.Title>{siteInfo.name}</Offcanvas.Title>
                    <Button variant="primary" className="btn btn-sm" onClick={showModalEdgeAlert}><BsExclamationSquare className="text-good"></BsExclamationSquare> Alert</Button>
                    <Button variant="primary" className="btn btn-sm ms-1" onClick={showModalEdgeHistory}><RxCounterClockwiseClock></RxCounterClockwiseClock> History</Button>
                    <Button variant='close' className="btn-close-white" onClick={closeOffcanvas}></Button>
                </Offcanvas.Header>
                <Offcanvas.Body className='dashboard-offcanvas'>
                    <div className="d-flex flex-column">
                        <div className="d-flex edge-list-table">
                            <table className="table text-center">
                                <tbody>
                                    {edgeList}                                    
                                </tbody>
                            </table>
                        </div>
                        <div className="d-flex div-title" onClick={toggleMemoColl} aria-controls="memoTab" aria-expanded={memoColl}>{memoColl?<BsChevronRight/>:<BsChevronDown/>}Memo</div>
                        <Collapse in={memoColl}>
                            <div id='memoTab'>
                                <div className="d-flex me-2 map-markdown-area" style={{height: memoHeight}}>
                                    <ReactMarkdown className='map-text-box markdown-body'
                                        children={siteInfo.memo}
                                        remarkPlugins={[remarkGfm, remarkToc]}
                                        rehypePlugins={[rehypeRaw, rehypeHighlight, rehypeSanitize]}
                                    />
                                </div>
                            </div>
                        </Collapse>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
            {modalEdgeHistory&&<HistoryModal historyInfo={{type:'site', value:siteInfo.name}} show={modalEdgeHistory} handleClose={closeModalEdgeHistory}></HistoryModal>}
            {modalEdgeAlert&&<AlertModal alertInfo={{type:'site', value:siteInfo.name}} show={modalEdgeAlert} handleClose={closeModalEdgeAlert}></AlertModal>}
            {modalEdgeInfo&&<EdgeInfoModal edgeId={edgeInfoId} show={modalEdgeInfo} handleClose={closeModalEdgeInfo}></EdgeInfoModal>}
        </>
    )
}

export const EdgeOffCanvas = ({siteUpdate, siteInfo, id, result, moveLocation, show, handleClose}) => {
    
    const term = '1';
    const refresh = 5000;
    const isStop = false;
    const reload = false;
    const isCalendar = false;

    const [update, setUpdate] = useState(false);
    const [memoColl, setMemoColl] = useState(true);
    const toggleMemoColl = () => {
        updateSession('edgeWidgetInfo', 'collapse', !memoColl);
        setMemoColl(!memoColl);
    }

    const [edgeInfo, setEdgeInfo] = useState(
        {
            "id": "",
            "fingerprint": "",
            "name": "",
            "status": "",
            "type": "",
            "longitude": 0,
            "latitude": 0,
            "link": "",
            "memo": "",
            "date": "",
            "locationMode": "",
            "transmissionStation": "",
            "site": "",
            "tag": "",
            "sec": 0,
            "changeCount": 0,
            "collectType": "",
            "severity": "",
            "clientIp": "",
            "metrics": ""
        }
    );
    
    const [modalEdgeAlert, setModalEdgeAlert] = useState(false);
    const closeModalEdgeAlert = () => setModalEdgeAlert(false);
    const showModalEdgeAlert = () => setModalEdgeAlert(true);
    
    const [modalEdgeHistory, setModalEdgeHistory] = useState(false);
    const closeModalEdgeHistory = () => setModalEdgeHistory(false);
    const showModalEdgeHistory = () => setModalEdgeHistory(true);

    const [edgeInfoId, setEdgeInfoId] = useState(null);
    const [modalEdgeInfo, setModalEdgeInfo] = useState(false);
    const closeModalEdgeInfo = () => setModalEdgeInfo(false);
    const showModalEdgeInfo = (edgeId) => {
        setEdgeInfoId(edgeId);
        setModalEdgeInfo(true);
    }

    const [widgetType, setWidgetType] = useState('');
    const [modalWidgetConfig, setModalWidgetConfig] = useState(false);
    const showModalWidgetConfig = (type) => {
        setWidgetType(type);
        setModalWidgetConfig(true);
    }
    const closeModalWidgetConfig = () => setModalWidgetConfig(false);

    const [property, setProperty] = useState({collapse:false, height:300, 'm-agent':[], 's-agent':[], 'r-agent':[], 'rm':[]});

    function runUpdate()
    {
        setUpdate(!update);
    }

    function goToSiteCanvas()
    {
        closeOffcanvas();
        result(siteInfo);
    }

    const closeOffcanvas = () => {
        handleClose();
        show = false;
    }

    useEffect(() => {
        Promise.resolve( getApiEdgeId(id) )
        .then( data => {
            setEdgeInfo(data)
        });
        
        
        const defaultProperty = {collapse:false, height:300, 'm-agent':[0,1], 's-agent':[0], 'r-agent':[0], 'rm':[0]};
        const get = getSession_Json('edgeWidgetInfo');
        if( get !== null )
        {
            // 구버전 세션(r-agent 등 누락된 키)과 기본값을 병합
            const merged = { ...defaultProperty, ...get };
            saveIfChange(setMemoColl, merged.collapse);
            saveIfChange(setProperty, merged);
        }
    }, [update, siteUpdate]);

    return (
        <TermRefreshContext.Provider value={{term, refresh, isStop, isCalendar, reload}}>
            <Offcanvas show={show} onHide={closeOffcanvas} placement="end">
                <Offcanvas.Header>
                    <Offcanvas.Title>
                        <div className="page-title">
                            <ul className="breadcrumb">
                                <li className='breadcrumb-item pointer' onClick={goToSiteCanvas}>{siteInfo.name}</li>
                                <li className='breadcrumb-item active'>{edgeInfo.name}</li>
                            </ul>
                        </div>
                    </Offcanvas.Title>
                    <Button variant="primary" className="btn btn-sm" onClick={showModalEdgeAlert}><BsExclamationSquare className="text-good"></BsExclamationSquare> Alert</Button>
                    <Button variant="primary" className="btn btn-sm ms-1" onClick={showModalEdgeHistory}><RxCounterClockwiseClock></RxCounterClockwiseClock> History</Button>
                    <Button variant='close' className="btn-close-white" onClick={closeOffcanvas}></Button>
                </Offcanvas.Header>
                <Offcanvas.Body className='dashboard-offcanvas'>
                    <div className="d-flex flex-column">
                        <div className="d-flex edge-list-table">
                        <table className="table text-center mb-1">
                                <tbody>
                                    <tr>
                                        <td>
                                            <div className={`edge-box bg-${edgeInfo.severity}`}>{edgeInfo.type==='m-agent'?'M':edgeInfo.type==='s-agent'?'S':edgeInfo.type==='r-agent'?'R':'T'}</div>
                                        </td>
                                        <td>
                                            <div className="label-edge">{edgeInfo.tag !== '' ? edgeInfo.tag : '-'}</div>
                                        </td>
                                        <td>
                                            <div className="label-edge">{edgeInfo.name}</div>
                                        </td>
                                        <td>
                                            <Button vatiant='primary' className="btn btn-icon" data-bs-toggle="tooltip" title="Details" onClick={()=>{showModalEdgeInfo(edgeInfo.id)}}><BsExclamationCircle></BsExclamationCircle></Button>
                                        </td>
                                        <td>
                                            <Button vatiant='primary' className="btn btn-icon" data-bs-toggle="tooltip" title="Link to Device" onClick={()=>{createNewTab(edgeInfo.link)}}><BsLink45Deg></BsLink45Deg></Button>
                                        </td>
                                        <td>
                                            <Button vatiant='primary' className="btn btn-icon" data-bs-toggle="tooltip" title="Location" onClick={()=>{moveLocation([edgeInfo.longitude, edgeInfo.latitude])}}><BsPinMap></BsPinMap></Button>
                                        </td>
                                    </tr>                             
                                </tbody>
                            </table>
                        </div>
                        {edgeInfo.id && <div className="text-center mb-1"><CheckEdgeMetric edgeId={edgeInfo.id} /></div>}
                        <Button variant='primary' className="btn btn-sm mb-2" onClick={() => {showModalWidgetConfig(edgeInfo.type)}}>Widget Config (All)</Button>
                        <div className="d-flex div-title" onClick={toggleMemoColl} aria-controls="memoTab" aria-expanded={memoColl}>{memoColl?<BsChevronRight/>:<BsChevronDown/>}Memo</div>
                        <Collapse in={memoColl}>
                            <div id='memoTab'>
                                <div className="d-flex me-2 map-markdown-area" style={{height: property.height}}>
                                    <ReactMarkdown className='map-text-box markdown-body'
                                        children={edgeInfo.memo}
                                        remarkPlugins={[remarkGfm, remarkToc]}
                                        rehypePlugins={[rehypeRaw, rehypeHighlight, rehypeSanitize]}
                                    />
                                </div>
                            </div>
                        </Collapse>
                        <div className="d-flex flex-wrap mt-2">
                            <EdgeWidget property={property} type={edgeInfo.type} id={id} edgeInfo={edgeInfo}/>
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
            {modalEdgeHistory&&<HistoryModal historyInfo={{type:'edge', value:edgeInfo.id}} show={modalEdgeHistory} handleClose={closeModalEdgeHistory}></HistoryModal>}
            {modalEdgeAlert&&<AlertModal alertInfo={{type:'edge', value:edgeInfo.id}} show={modalEdgeAlert} handleClose={closeModalEdgeAlert}></AlertModal>}
            {modalEdgeInfo&&<EdgeInfoModal edgeId={edgeInfoId} show={modalEdgeInfo} handleClose={closeModalEdgeInfo}></EdgeInfoModal>}
            {modalWidgetConfig&&<EdgeWidgetConfigModal type={widgetType} update={runUpdate} show={modalWidgetConfig} handleClose={closeModalWidgetConfig}></EdgeWidgetConfigModal>}
        </TermRefreshContext.Provider>
    )
}

const EdgeWidget = ({property, type, id, edgeInfo}) => {

    const [html, setHtml] = useState(null);
    const [update, setUpdate] = useState(false);

    const [parseMetrics, setParseMetrics] = useState(null);
    const [gidTidServiceData, setGidTidServiceData] = useState([]);

    const [widgetComponent, setWidgetComponent] = useState(null);

    const {term, refresh, isStop, isCalendar, reload} = useContext(TermRefreshContext);

    useEffect( () => {
        const defaultKeys = { 'm-agent': [0, 1], 's-agent': [0], 'r-agent': [0], 'rm': [0] };
        const keys = (Array.isArray(property[type]) && property[type].length > 0)
            ? property[type]
            : (defaultKeys[type] ?? []);
        if( keys.length > 0 && widgetComponent && widgetComponent[type] )
        {
            setHtml( keys.map((key) => 
                widgetComponent[type][key]
            ));
        }
    }, [widgetComponent]);

    useEffect(() => {
        Promise.resolve(getApiEdgeIdMetrics(id))
        .then(data =>
        {
            const obj = parse_metrics_body(data);
            saveIfChange(setParseMetrics, obj.metrics);
            Media.getGidTidServiceData(obj.metrics, setGidTidServiceData);
        });
    }, [update]);

    useEffect( () => {
        setWidgetComponent({
            'm-agent':[
                <div key='MsystemInfo' className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                    <Media.MsystemInfo metricsObj={parseMetrics} pageName={'subPage'}/>
                </div>,
                <div key='MediaMonitoringStatus' className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <Media.MediaMonitoringStatus metricsObj={parseMetrics} muxOutputValue={null} pageName={'subPage'} edgeId={edgeInfo.id}/>
                </div>,
                <div key='ServiceInfoTable' className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                    { gidTidServiceData.length > 0
                        ?<Media.ServiceInfoTableForDash llsInfo={gidTidServiceData[0]} serviceId={gidTidServiceData[0].svcId} edgeId={edgeInfo.id} isCalendar={isCalendar}/>
                        :<Media.ServiceInfoTableForDash llsInfo={null} serviceId={null} edgeId={null} isCalendar={isCalendar}/>
                    }
                </div>,
                <div key='ModuleStatusTable' className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                    <Media.ModuleStatusTable metricsObj={parseMetrics}/>
                </div>,
                <div key='MconfigInfo' className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                    <Media.MconfigInfo metricsObj={parseMetrics} pageName={'subPage'}/>
                </div>,
                <div key='SoftwareInfoTable' className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                    <Media.SoftwareInfoTable metricsObj={parseMetrics}/>
                </div>,
                <div key='MediaCpuChart' className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                    <Media.MediaCpuChart edgeId={edgeInfo.id}/>
                </div>,
                <div key='MediaMemChart' className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                    <Media.MediaMemChart edgeId={edgeInfo.id}/>
                </div>,
                <div key='MediaDiskChart' className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                    <Media.MediaDiskChart edgeId={edgeInfo.id}/>
                </div>,
                <div key='MuxOutputChart' className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                    <Media.MuxOutputChart edgeId={edgeInfo.id} setMuxOutputStatus={()=>{}}/>
                </div>,
                <div key='LlsChart' className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                    { gidTidServiceData.length > 0
                        ?<Media.LlsChart llsInfo={gidTidServiceData[0]} edgeId={edgeInfo.id}/>
                        :<Media.LlsChart llsInfo={null} edgeId={edgeInfo.id}/>
                    }
                </div>
            ],
            's-agent':[
                <div key='SchedulerMonitoringStatus' className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <Scheduler.SchedulerMonitoringStatus metricsObj={parseMetrics} pageName={'subPage'} edgeId={edgeInfo.id}/>
                </div>,
                <div key='DigicasterSinfo' className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                    <Scheduler.DigicasterSinfo edgeId={edgeInfo.id} pageName={'subPage'}/>
                </div>,
                <div key='SsystemSystemUsageChart' className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                    <Scheduler.SsystemCpuChart edgeId={edgeInfo.id} pageName={'subPage'}/>
                    <Scheduler.SsystemMemChart edgeId={edgeInfo.id} pageName={'subPage'}/>
                    <Scheduler.SsystemDiskChart edgeId={edgeInfo.id} pageName={'subPage'}/>
                </div>,
                <div key='SsystemOutputBitrateChart' className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                    <Scheduler.SsystemOutputBitrateChart edgeId={edgeInfo.id}/>
                </div>,
                <div key='SpectrumResourceTableForDashBoard' className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <Scheduler.SpectrumResourceTableForDashBoard edgeId={edgeInfo.id}/>
                </div>,
                <div key='ServiceTableForDashBoard' className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <Scheduler.ServiceTableForDashBoard edgeId={edgeInfo.id}/>
                </div>,
                <div key='FrameTimeForDashboard' className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <Scheduler.FrameTimeForDashboard metricsObj={parseMetrics}/>
                </div>
            ],
            'r-agent':[
                <div key='RedundantMonitoringStatus' className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <Redundant.RedundantMonitoringStatus metricsObj={parseMetrics} edgeId={edgeInfo.id} pageName={'subPage'}/>
                </div>,
                <div key='RedundantMonitoringInputGroups' className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <Redundant.RedundantInputGroupsForDashBoard edgeId={edgeInfo.id} metricsObj={parseMetrics} pageName={'subPage'}/>
                </div>
            ],
            'rm':[
                <div key='StlInfoForDashBoard' className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <Transmitter.StlInfoForDashBoard metricsObj={parseMetrics}/>
                </div>,
                <div key='StlTimeInfoForDashBoard' className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <Transmitter.StlTimeInfoForDashBoard metricsObj={parseMetrics}/>
                </div>,
                <div key='TunerGpsTime' className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <Transmitter.TunerGpsTime metricsObj={parseMetrics}/>
                </div>,
                <div key='TmOutputBitrateChart' className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                    <Transmitter.TmOutputBitrateChart edgeId={edgeInfo.id}/>
                </div>,
                <div key='TmFecOverheadChart' className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                    <Transmitter.TmFecOverheadChart edgeId={edgeInfo.id} dash='dash'/>
                </div>,
                <div key='TmRtpErrorCountChart' className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <div className="section chart">
                    <div className="section-title">Error Count</div>
                        <Transmitter.TmRtpErrorCountChart edgeId={edgeInfo.id} />
                        <hr />
                        <Transmitter.TmFecRepairCountChart edgeId={edgeInfo.id} />
                    </div>
                </div>,
                <div key='TmNetworkDelayChart' className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                    <Transmitter.TmNetworkDelayChart edgeId={edgeInfo.id} dash='dash'/>
                </div>,
                <div key='TmMndChart' className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                    <Transmitter.TmMndChart edgeId={edgeInfo.id} dash='dash'/>
                </div>,
                <div key='TmMwBandwidthChart' className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                    <Transmitter.TmMwBandwidthChart edgeId={edgeInfo.id} dash='dash'/>
                </div>,
                <div key='TmRfRssiChart' className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                    <Transmitter.TmRfRssiChart edgeId={edgeInfo.id} dash='dash'/>
                </div>,
                <div key='TmRfMerChart' className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                    <Transmitter.TmRfMerChart edgeId={edgeInfo.id}/>
                </div>,
                <div key='TmRfSnrChart' className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                    <Transmitter.TmRfSnrChart edgeId={edgeInfo.id}/>
                </div>,
                <div key='TmRfFerChart' className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                    <Transmitter.TmRfFerChart edgeId={edgeInfo.id}/>
                </div>
            ]
        });
    }, [property, parseMetrics]);

    function runUpdate()
    {
        setUpdate(!update);
    }
    
    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);
    
    useEffect(() => {
        runUpdate();
    }, [JSON.stringify(edgeInfo)]);


    return (
        <>
            {html}
        </>
    )
}